<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Grievance Redressal"
                   :links="[{title:'Home', url:'/'},{title:'Grievance Redressal'}]"></page-header>
      <section class="section">
        <div class="container1">
          <div class="heading-black1">Grievance Redressal Committee</div>
          <committee-component :members="members"></committee-component>
        </div>
      </section>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>

import NavbarComponent from "../../components/Navbar.vue";
import FooterComponent from "../../components/Footer.vue";
import PageHeader from "../../components/PageHeader";
import Programmes from "@/views/about/Programmes";
import CommitteeComponent from "@/components/CommitteeComponent";

export default {
  name: "GrievanceRedressal",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    FooterComponent,
    CommitteeComponent
  },

  data() {
    return {
      members: [
        {
          name: 'Dr. P. M. Patil',
          designation: 'Chairman (Principal)'
        }, {
          name: 'Prof. Dhakne V.N',
          designation: 'Nodal Officer (I/C) (Computer Engineering)'
        }, {
          name: ' Prof. A. M. Solanki',
          designation: 'Member (TPO)'
        }, {
          name: 'Miss. Khemnar K. N.',
          designation: 'Member (Electrical Engineering)'
        }, {
          name: 'Mr. Jamdhade C. G.',
          designation: 'Member (Applied Science)'
        }, {
          name: 'Mr. Datta Mahale',
          designation: 'Member (Local Media)'
        }, {
          name: 'Mr. Sandip Koli',
          designation: 'Member (Police Representative)'
        },{
          name: 'Mr. Lachke Mukesh',
          designation: 'Member (NGO Representative)'
        },{
          name: 'Mr. Sopan Kokate',
          designation: 'Member (Parent Representative)'
        },{
          name: 'Mr. Sonwane Mayur V.',
          designation: 'Member (Student Representative)'
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped/>

